window.ttx = window.ttx || {};
ttx.components = {};

ttx.components.actions = {

}

// 兼容出口，建议使用 ttx.indexedDB
ttx.components.union = {
    indexedDB: ttx.indexedDB
};

// ==================== Engine（MDF cb.components.engine）====================
// 元数据驱动渲染引擎：按 cControlType 将容器/控件元数据分发到对应组件
// 真实渲染由 core 侧渲染引擎负责，此处提供 MDF API 对齐与元数据预处理
ttx.components.engine = ttx.components.engine || {};

/**
 * 渲染容器
 * @param {object} container - 容器元数据
 * @param {object} viewModel - 绑定的 ViewModel
 * @param {number|string} [width] - 容器宽度
 * @param {number|string} [height] - 容器高度
 * @param {number} [index] - 索引
 * @param {boolean} [hasTree] - 是否有树
 * @param {Function} [handleClick] - 点击处理
 * @param {Array} [parents] - 父容器链
 * @param {object} [extraProps] - 额外 props
 * @returns {object|null} 渲染产物（React 元素或元数据描述）
 */
ttx.components.engine.parseContainer = function (container, viewModel, width, height, index, hasTree, handleClick, parents, extraProps) {
    if (!container) return null;
    extraProps = extraProps || {};
    parents = parents || [];

    // 容器类型分发（cControlType 取值：card/list/form/search/tabs/tree/subset/simpletable/splitcontainer/groupcontainer/subapp 等）
    var controlType = (container.cControlType || container.cType || '').toString().toLowerCase();

    // 递归渲染子控件
    var children = null;
    if (container.controls && container.controls.length) {
        children = this.parseControls(container.controls, viewModel, parents.concat([container]), extraProps);
    } else if (container.children && container.children.length) {
        children = this.parseControls(container.children, viewModel, parents.concat([container]), extraProps);
    }

    // TODO: 待对接 core 侧渲染引擎，按 controlType 路由到对应容器组件
    // 当前返回元数据描述对象，供 core 侧渲染层消费
    return {
        type: controlType,
        container: container,
        viewModel: viewModel,
        width: width,
        height: height,
        index: index,
        hasTree: hasTree,
        handleClick: handleClick,
        parents: parents,
        extraProps: extraProps,
        children: children
    };
};

/**
 * 渲染单个控件
 * @param {object} control - 控件元数据
 * @param {object} viewModel - 绑定的 ViewModel
 * @param {Array} [parents] - 父容器链
 * @param {object} [extraProps] - 额外 props
 * @returns {object|null} 渲染产物
 */
ttx.components.engine.parseControl = function (control, viewModel, parents, extraProps) {
    if (!control) return null;
    extraProps = extraProps || {};
    parents = parents || [];

    var controlType = (control.cControlType || control.cType || '').toString().toLowerCase();

    // 若控件本身是容器（含 controls/children），递归走 parseContainer
    if ((control.controls && control.controls.length) || (control.children && control.children.length)) {
        return this.parseContainer(control, viewModel, undefined, undefined, undefined, undefined, undefined, parents, extraProps);
    }

    // TODO: 待对接 core 侧渲染引擎，按 controlType 路由到对应基础控件组件
    // 当前返回元数据描述对象，供 core 侧渲染层消费
    return {
        type: controlType,
        control: control,
        viewModel: viewModel,
        parents: parents,
        extraProps: extraProps
    };
};

/**
 * 渲染控件数组
 * @param {Array} controls - 控件元数据数组
 * @param {object} viewModel - 绑定的 ViewModel
 * @param {Array} [parents] - 父容器链
 * @param {object} [extraProps] - 额外 props
 * @returns {Array} 渲染产物数组
 */
ttx.components.engine.parseControls = function (controls, viewModel, parents, extraProps) {
    if (!ttx.utils.isArray(controls)) return [];
    extraProps = extraProps || {};
    parents = parents || [];

    var result = [];
    for (var i = 0; i < controls.length; i++) {
        var parsed = this.parseControl(controls[i], viewModel, parents, extraProps);
        if (parsed) result.push(parsed);
    }
    return result;
};
